import {groupBy, sortBy} from 'lodash'

import {
  KpiDefinitionDto,
  KpiTabValuesDto,
  SlaTableDataGroupRow,
  SlaTableDataItemRow,
  SlaTableDataRow,
  SlaTargetDto,
  SlaTargetType
} from '../types'

export const mapSlaTargetToSlaTableDataItemTarget = (targetDto: SlaTargetDto): string => {
  const {targetValue, minValue, maxValue, unit, targetType} = targetDto

  switch (targetType) {
    case SlaTargetType.Range:
      return minValue && maxValue && unit ? `${minValue} - ${maxValue}` : ''
    case SlaTargetType.LessThan:
      return targetValue || targetValue === 0 ? `< ${targetValue}` : ''
    case SlaTargetType.GreaterThan:
      return targetValue || targetValue === 0 ? `> ${targetValue}` : ''
    default:
      return ''
  }
}

export const mapKpiDefinitionToSlaTableDataItem = (
  kpiDef: KpiDefinitionDto
): SlaTableDataItemRow => ({
  id: kpiDef.id,
  type: 'item',
  year: kpiDef.year,
  subItems: [],
  dataField: kpiDef.name,
  unit: kpiDef.slaTarget.unit,
  target: mapSlaTargetToSlaTableDataItemTarget(kpiDef.slaTarget),
  kpiValues: kpiDef.kpiValues,
  cceKpiDefinitionId: kpiDef.cceKpiDefinitionId
})

export const mapKpiTabValuesToSlaTableDataItems = (data: KpiTabValuesDto): SlaTableDataRow[] => {
  const NO_GROUP_ID = 'NO_GROUP_ID'

  const groupedByGroupId = groupBy(
    data.kpiDefinitions,
    (option) => option.kpiGroupId ?? NO_GROUP_ID
  )

  const groupedBy = sortBy(
    Object.entries(groupedByGroupId)
      .map(([kpiGroupId, kpiDefs]) => {
        if (kpiGroupId === NO_GROUP_ID) {
          return kpiDefs.map(mapKpiDefinitionToSlaTableDataItem)
        }

        const group = data.kpiGroups?.find((x) => x.id === kpiGroupId)
        const subItems = sortBy(kpiDefs, (option) => option.name).map(
          mapKpiDefinitionToSlaTableDataItem
        )

        const groupItem: SlaTableDataGroupRow = {
          id: kpiGroupId,
          type: 'group',
          year: kpiDefs[0].year,
          subItems: subItems,
          dataField: group?.name
        }

        return groupItem
      })
      .flat(),
    (opt) => opt.dataField
  )

  return groupedBy
}
